import { important } from "@nvon/react-toolbox";
import { makeStyles } from "tss-react/mui";

export const useNWONTextWithImagesStyles = makeStyles()((theme) => ({
  wrapper: {
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "row",
    [theme.breakpoints.down("md")]: {
      rowGap: theme.spacing(2),
    },
  },
  animationWrapper: {
    "& div": {
      maxWidth: "auto",
    },
  },
  imageWrapper: {
    width: "100%",
    maxHeight: theme.spacing(30),
    "& > *": {
      maxHeight: important(theme.spacing(30)),
    },
  },
  image: {
    objectFit: "scale-down",
    objectPosition: "center",
    width: "100%",
  },
  info: {
    alignSelf: "center",
    justifySelf: "center",
    padding: theme.spacing(0, 6),
    [theme.breakpoints.down("md")]: {
      padding: "0 !important",
    },
  },
  mediaWrapper: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "& > svg": {
      maxHeight: "300px",
      width: "auto",
      padding: theme.spacing(4, 0),
      [theme.breakpoints.only("xs")]: {
        maxWidth: "80px",
        padding: theme.spacing(2, 0),
      },
    },
  },
  orderFirst: {
    [theme.breakpoints.down("md")]: {
      order: 1,
    },
  },
  orderSecond: {
    [theme.breakpoints.down("md")]: {
      order: 2,
    },
  },
}));
